const initClaimsProductTooltip = () => {
    const wrapper = document.querySelector('.main-product__claims-tooltip');
    if (!wrapper) return;

    const tooltipContainer = wrapper.querySelector('.claims-tooltips');
    if (!tooltipContainer) return;

    const products = wrapper.querySelectorAll('.claims-product[data-tooltip]');
    let activeIcon = null;

    const showTooltip = (icon) => {
        const product = icon.closest('.claims-product');
        const content = product.querySelector('.claims-product__tt-cnt');
        if (!content) return;

        tooltipContainer.innerHTML = content.innerHTML;
        tooltipContainer.classList.add('is-visible');
        activeIcon = icon;
    };

    const hideTooltip = () => {
        tooltipContainer.classList.remove('is-visible');
        tooltipContainer.innerHTML = '';
        activeIcon = null;
    };

    products.forEach(product => {
        const icon = product.querySelector('.claims-product__tt-i');
        if (!icon) return;

        const handleShow = (e) => {
            e.stopPropagation();
            showTooltip(icon);
        };

        icon.addEventListener('mouseenter', handleShow);
        icon.addEventListener('focus', handleShow);

        icon.addEventListener('mouseleave', () => {
            if (activeIcon === icon) hideTooltip();
        });
        icon.addEventListener('blur', () => {
            if (activeIcon === icon) hideTooltip();
        });

        icon.addEventListener('touchstart', e => {
            e.preventDefault();
            handleShow(e);
        });
    });

    const clickOutsideHandler = (e) => {
        if (activeIcon && !activeIcon.contains(e.target)) {
            hideTooltip();
        }
    };

    document.addEventListener('click', clickOutsideHandler);
    document.addEventListener('touchstart', clickOutsideHandler);
};

export { initClaimsProductTooltip };